import styled from "styled-components";

const Attrs = styled.svg.attrs({
  xmlns: "http://www.w3.org/2000/svg",
})``;

const DotImg = styled(Attrs)`
  width: 10px;
  height: 10px;
  fill: none;
`;

type Props = {
  color: string;
};

export default function DotImage({ color }: Props) {
  return (
    <DotImg viewBox="0 0 10 10">
      <rect width="10" height="10" fill={color} />
    </DotImg>
  );
}
